import React, { useState, useEffect } from "react";
import { Container, Stack, Button, Typography, Box } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { useNetwork } from "../providers/NetworkProvider";
import { usePaymentsProvider } from "../providers/PaymentsProvider";
import "../styles/products.css";

const ChecklistItem = ({ item }: { item: string }) => (
	<Box
		sx={{
			display: "flex",
			gap: 2,
			marginBottom: 10,
		}}
	>
		<CheckIcon fontSize="small" sx={{ color: "white" }} />
		<Typography variant="body1" sx={{ color: "white", fontWeight: "bold" }}>
			{item}
		</Typography>
	</Box>
);

const AdvantagesChecklist = ({ advantages }: { advantages: string[] }) => (
	<Box>
		{advantages.map((advantage, index) => (
			<ChecklistItem key={index} item={advantage} />
		))}
	</Box>
);

export const Products = () => {
	const { makePost } = useNetwork();
	const { getPlans, plans } = usePaymentsProvider();
	const [showYearly, setShowYearly] = useState(false);

	const handlePurchase = async (priceId: string) => {
		try {
			const response = await makePost("payments/stripe/stripeSession", {
				priceId: priceId,
			});
			console.log(response);
			window.location.href = response.data.url;
		} catch (err) {
			console.log(err);
		}
	};

	useEffect(() => {
		getPlans();
	}, []);

	return (
		<>
			<Box
				sx={{
					marginTop: "32px",
					display: "flex",
					alignItems: "center",
					flexDirection: "column",
					gap: "32px",
				}}
			>
				<Container
					sx={{
						// height:"32px",
						borderRadius: "32px",
						border: "1px white solid",
						display: "flex",
						width: "fit-content",
					}}
				>
					<Button
						onClick={() => setShowYearly(true)}
						color="secondary"
					>
						Yearly
					</Button>
					<Button
						onClick={() => setShowYearly(false)}
						color="secondary"
					>
						Monthly
					</Button>
				</Container>
				<Container
					sx={{
						display: "grid",
						gridTemplateColumns:
							"repeat(auto-fill, minmax(300px, 1fr))",
						gap: "16px",
						padding: "8px",
					}}
				>
					{plans.map((value, index) => (
						<Stack
							key={index}
							spacing={2}
							sx={{
								maxWidth: 440,
								margin: "auto",
								display: "block",
							}}
							className="cardContainer"
						>
							<Typography
								variant="h5"
								sx={{ color: "white", fontWeight: "bold" }}
							>
								{value.title}{" "}
								{showYearly ? "yearly" : "monthly"}
							</Typography>
							<Typography
								variant="body1"
								sx={{ color: "white", fontWeight: "bold" }}
							>
								{showYearly
									? value.yearly.description
									: value.monthly.description}
							</Typography>
							<AdvantagesChecklist
								advantages={
									showYearly
										? value.yearly.advantages
										: value.monthly.advantages
								}
							/>
							<Button
								onClick={async () => {
									await handlePurchase(
										showYearly
											? value.yearly.stripePriceId
											: value.monthly.stripePriceId
									);
								}}
								color="secondary"
							>
								{value.title}
							</Button>
						</Stack>
					))}
				</Container>
			</Box>
		</>
	);
};
//price_1P852ZANVtnBUNBJgolWGzzK
